export default __webpack_public_path__ + "static/media/blur 1.09996122.jpg";